module.exports = __webpack_public_path__ + "img/4B.7c1099e2.jpeg";